import React, { useEffect} from 'react';
import { Card, Col, Divider, message, Row} from 'antd';
import seguridadProvider from '../../../services/seguridadProvider';
import { irLoginEleccion } from '../../../utils/navegar-login-eleccion';
import { useLocation } from 'react-router-dom';

const QRCode = require('qrcode.react');

const ResultadoVoto = () => {
  const location: any = useLocation();
  const validarSesion = async () => {
    return await seguridadProvider.obtenerFechaHora().catch((err) => {
      if (err.request.status === 401) {
        message.warning('No esta permitido!');
        irLoginEleccion();
      }
    });
  };

  useEffect(() => {
    validarSesion()
      .then((res) => {
        console.info('respuesta:', res);
      })
      .catch((err) => {
        console.info('err', err);
      });
  }, []);

  return (
    <>
      <div className='row'>
        <div className='col-md-12'>
          <Card
            className='custom-bg-color'
            style={{
              padding: '0 15px',
              backgroundImage:
                'linear-gradient(to right, rgb(243, 243, 244) 0%, rgb(225, 225, 226) 100%)',
              color: 'rgb(31, 32, 34)'
            }}
          >
            <div className='row'>
              <div className='col-12'>
                <Row justify={'center'}>
                  <Col>
                    <h3 style={{ textAlign: 'center' }}>GRACIAS POR PARTICIPAR EN LA <br /> 'Proceso de elección de los Representantes de los Trabajadores para el Comité de Intervención frente al Hostigamiento Sexual Laboral 2026-2028 de TGESTIONA SERVICIOS GLOBALES S.A.C'</h3>
                    <p style={{ textAlign: 'center' }}>si lo desea, guarde esta pantalla como constancia de la
                      votación</p>
                  </Col>
                </Row>
                <Row justify={'center'}>
                  <Col>
                    <Divider />
                    <QRCode value={location.state ? location.state : 'tgestiona'} />
                  </Col>
                </Row>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default ResultadoVoto;
